import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, AuthenticationService} from '../../_services/index';

import {LoginHelper} from '../../helpers';

import {MatDialog} from '@angular/material/dialog';
import {ApiKeyService} from "../../_services/apiKey.service";
import {ApiKey} from "../../_models/apiKey";

@Component({
    standalone: false,
  selector: "apiKeys-component",
  templateUrl: 'apiKeys.component.html',
  styleUrls: ['./apiKeys.component.scss'],
})

export class ApiKeysComponent implements OnInit {
  apiKeys: ApiKey[];
  msg: string;
  password: string = '';

  cols : any[] = [
    {'field': 'key', 'header': 'Key'},
  ]
  navigator = window.navigator;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public apiKeyService: ApiKeyService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dialog: MatDialog) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
  }

  loadKeys() {

    this.apiKeyService.getAll(this.password).subscribe(data => {
        this.apiKeys = data;
      },
      (error: Response) => {
        const errorMessage = JSON.parse((<any>error).error.message).error || 'An error occurred while getting api keys.';
        this.alertService.error(errorMessage);
      });
  }
  create() {

    this.apiKeyService.create().subscribe(data => {
        this.loadKeys();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while creating api key.';
        this.alertService.error(errorMessage);
      });
  }
  delete(id) {

    this.apiKeyService.delete(id).subscribe(data => {
        this.loadKeys();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while deleting api key.';
        this.alertService.error(errorMessage);
      });
  }

  setIsGet(id, val){
    this.apiKeyService.setIsGet(id, val).subscribe(d => {
      this.loadKeys();
    })
  }

  clipboard(key){
    navigator.clipboard.writeText(key);
    this.alertService.success('Copied to Clipboard');
  }

  setIsPost(id, val){
    this.apiKeyService.setIsPost(id, val).subscribe(d => {
      this.loadKeys();
    })
  }
}
